import React, { FC } from "react";

interface SmallLogoProps {
  color?: string;
  height: number;
}
export const SmallLogo: FC<SmallLogoProps> = ({ color = "white", height }) => {
  return (
    <svg
      fill={color}
      viewBox="0 0 300 187.09"
      xmlns="http://www.w3.org/2000/svg"
      height={height}
    >
      <g>
        <path
          d="M5.67,35.47v25.95c0.14-0.02,0.28-0.03,0.42-0.05c18.68-2.2,35.11,12.4,35.11,31.21v88.79h25.73V81.2
		c0-15.35,11.66-28.23,27-29.69c14.3-1.37,26.03,9.69,26.03,24.05v105.8h25.73V78.51c0-18.71,14.1-34.42,32.72-36.43
		c17.38-1.87,32.44,12.05,32.44,29.53v109.75h25.73V71.73c0-20.47,15.24-37.65,35.53-40.11V5.73L5.67,35.47z"
        />
      </g>
    </svg>
  );
};
